import { render } from "./ToggleScreen.vue?vue&type=template&id=3fc62c10&ts=true"
import script from "./ToggleScreen.vue?vue&type=script&lang=ts"
export * from "./ToggleScreen.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__